import { render, staticRenderFns } from "./DialogShell.vue?vue&type=template&id=e6919236&"
import script from "./DialogShell.vue?vue&type=script&lang=js&"
export * from "./DialogShell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6919236')) {
      api.createRecord('e6919236', component.options)
    } else {
      api.reload('e6919236', component.options)
    }
    module.hot.accept("./DialogShell.vue?vue&type=template&id=e6919236&", function () {
      api.rerender('e6919236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/dialog/DialogShell.vue"
export default component.exports